import { render, staticRenderFns } from "./LanceProsthetic.vue?vue&type=template&id=aabecb7e&"
import script from "./LanceProsthetic.vue?vue&type=script&lang=js&"
export * from "./LanceProsthetic.vue?vue&type=script&lang=js&"
import style0 from "./LanceProsthetic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports